import { AccessibeAccount } from '../type/AccessibeAccount';
import { AccessibeUser } from '../type/AccessibeUser';
import axios from '../utils/axiosInstance';

type RefreshedUserData = {
  account: AccessibeAccount;
  user: AccessibeUser;
};

export const useRefreshUserData = () => {
  const refreshUserData = async (): Promise<RefreshedUserData | null> => {
    const response = await axios.get('/api/accessibe/get-user', {
      withCredentials: true,
    });

    const account: AccessibeAccount = response.data.account;

    const user: AccessibeUser = {
      userId: response.data._id,
      email: response.data.email,
      fullName: response.data.name,
      activeAccountId: response.data.account?._id,
      phoneNumber: response.data.phone,
      countryCode: response.data.country,
    };

    return { account, user };
  };

  return { refreshUserData };
};
